// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Modal_wrapper__Ebh3M","content":"Modal_content__ESs5q","close":"Modal_close__k2CRd"};